import { render, staticRenderFns } from "./FormDadosAtendimento.vue?vue&type=template&id=4eef0a5c"
import script from "./FormDadosAtendimento.vue?vue&type=script&lang=js"
export * from "./FormDadosAtendimento.vue?vue&type=script&lang=js"
import style0 from "./FormDadosAtendimento.vue?vue&type=style&index=0&id=4eef0a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports